import { render, staticRenderFns } from "./budgetBid.vue?vue&type=template&id=0a217b65&scoped=true&"
import script from "./budgetBid.vue?vue&type=script&lang=js&"
export * from "./budgetBid.vue?vue&type=script&lang=js&"
import style0 from "./budgetBid.vue?vue&type=style&index=0&id=0a217b65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a217b65",
  null
  
)

export default component.exports